import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function NumberOfDependants() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [numberOfDependants, setNumberOfDependants] = useState([]);

  useEffect(() => {
    CommonService.getNumberOfDependats().then((data) =>
      setNumberOfDependants(data)
    );
  }, []);

  return (
    <fieldset>
      <legend>{t("Nº of dependants")}</legend>
      <select
        name="numberOfDependantId"
        value={searchObject.numberOfDependantId || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value=""></option>
        {numberOfDependants.map((numberOFdependant) => (
          <option value={numberOFdependant.id} key={numberOFdependant.id}>
            {t(numberOFdependant.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
